import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Organization } from 'data/terra/Organization';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { setNoneStringItem } from 'util/localStorage';
import { OrganizationsState } from '../reducer';
import localStorageConstants from 'constants/localStorage';
import { fetchProjects } from 'v2/store/projectList/actions/FetchProjects';

export const SELECT_ORGANIZATION = 'organizations/select';

export interface SelectOrganizationAction {
  type: typeof SELECT_ORGANIZATION;
  organization: Organization;
}

export const selectOrganization = (
  organization: Organization
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: SELECT_ORGANIZATION,
    organization,
  } as SelectOrganizationAction);

  setNoneStringItem(
    localStorageConstants.USER_LAST_SELECTED_ORGANIZATION_ID,
    organization.id
  );

  dispatch(fetchProjects());
};

export const selectOrganizationDelegate: DelegateMapEntry<
  SelectOrganizationAction,
  OrganizationsState
> = {
  [SELECT_ORGANIZATION]: (
    state: OrganizationsState,
    action: SelectOrganizationAction
  ): OrganizationsState => {
    return {
      ...state,
      selectedOrganization: action.organization,
    };
  },
};
